/**
 * LSHK F04 — client-side personalization name limits (draft theme workaround)
 * Enforce: max 12 Latin letters, max 3 CJK characters (scripts counted separately).
 * Does not silently trim. HulkApps plan blocks character_limit; this is storefront-only.
 */
(function () {
  'use strict';
  if (window.__lshkPersonalizationLimits) return;
  window.__lshkPersonalizationLimits = true;

  var MAX_LATIN = 12;
  var MAX_CJK = 3;
  var HELP_EN = 'Max 12 English letters or 3 Chinese characters.';
  var HELP_ZH = '最多 12 個英文字母或 3 個中文字。';
  var ERR_EMPTY_EN = 'Please enter the name to personalise.';
  var ERR_EMPTY_ZH = '請輸入要客製化的名字。';
  var ERR_LIMIT_EN = 'Name is too long: use up to 12 English letters or 3 Chinese characters.';
  var ERR_LIMIT_ZH = '名字過長：最多 12 個英文字母或 3 個中文字。';

  function isZh() {
    return (document.documentElement.lang || '').toLowerCase().indexOf('zh') === 0 ||
      /\/zh(\/|$)/.test(location.pathname);
  }
  function t(en, zh) { return isZh() ? zh : en; }

  function countScripts(value) {
    var latin = 0, cjk = 0;
    for (var i = 0; i < value.length; i++) {
      var ch = value.charAt(i);
      var code = value.charCodeAt(i);
      // Basic Latin letters only for the English quota
      if ((code >= 65 && code <= 90) || (code >= 97 && code <= 122)) {
        latin++;
        continue;
      }
      // CJK Unified Ideographs + common extensions / compatibility
      if (
        (code >= 0x4e00 && code <= 0x9fff) ||
        (code >= 0x3400 && code <= 0x4dbf) ||
        (code >= 0xf900 && code <= 0xfaff) ||
        (code >= 0x3007 && code <= 0x3007)
      ) {
        cjk++;
        continue;
      }
      // Surrogate pairs for rarer CJK
      if (code >= 0xd800 && code <= 0xdbff && i + 1 < value.length) {
        var full = value.codePointAt(i);
        if (
          (full >= 0x20000 && full <= 0x2a6df) ||
          (full >= 0x2a700 && full <= 0x2b73f) ||
          (full >= 0x2b740 && full <= 0x2b81f) ||
          (full >= 0x2b820 && full <= 0x2ceaf)
        ) {
          cjk++;
        }
        i++;
      }
    }
    return { latin: latin, cjk: cjk };
  }

  function validate(value) {
    var trimmed = (value || '').trim();
    if (!trimmed) {
      return { ok: false, reason: 'empty', message: t(ERR_EMPTY_EN, ERR_EMPTY_ZH) };
    }
    var c = countScripts(trimmed);
    if (c.latin > MAX_LATIN || c.cjk > MAX_CJK) {
      return { ok: false, reason: 'limit', message: t(ERR_LIMIT_EN, ERR_LIMIT_ZH), counts: c };
    }
    return { ok: true, counts: c };
  }

  function isNameInput(el) {
    if (!el || el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA') return false;
    if (el.type && el.type !== 'text' && el.tagName === 'INPUT') return false;
    if (el.closest('header, footer, .newsletter, [id*="Search"], .search__input')) return false;
    var cls = (el.className || '') + '';
    var ph = (el.placeholder || '');
    var key = el.getAttribute('data-option-key') || '';
    if (cls.indexOf('hulkapps_option_child') !== -1 && (key.indexOf('tb_') === 0 || /jessica|嘉欣|name|名字/i.test(ph))) return true;
    if (cls.indexOf('hulkapps') !== -1 && el.type === 'text') return true;
    if (/jessica\s*\/\s*嘉欣/i.test(ph)) return true;
    return false;
  }

  function findNameInputs(root) {
    root = root || document;
    return Array.prototype.slice.call(root.querySelectorAll('input[type="text"], textarea')).filter(isNameInput);
  }

  function cleanupDuplicates(input) {
    var parent = input.parentElement;
    if (!parent) return;
    var helps = parent.querySelectorAll(':scope > .lshk-po-help');
    var errs = parent.querySelectorAll(':scope > .lshk-po-error');
    // Also catch siblings inserted after input in broader option wrappers
    var wrap = input.closest('.hulkapps_option, .hulk-po-option, [class*="hulkapps_option"], .hulkapps_option_child') || parent;
    helps = wrap.querySelectorAll('.lshk-po-help');
    errs = wrap.querySelectorAll('.lshk-po-error');
    for (var i = 1; i < helps.length; i++) helps[i].remove();
    for (var j = 1; j < errs.length; j++) errs[j].remove();
  }

  function ensureLabelAndHelp(input) {
    if (!input || !input.parentElement) return { help: null, err: null, wrap: null };
    cleanupDuplicates(input);

    var id = input.id || ('lshk-name-' + Math.random().toString(36).slice(2, 8));
    if (!input.id) input.id = id;

    if (!input.getAttribute('aria-label')) {
      input.setAttribute('aria-label', t(
        'Name of the little one (English or Chinese)',
        '寶寶名字（英文或中文）'
      ));
    }

    var helpId = id + '-lshk-help';
    var errId = id + '-lshk-error';
    var help = input.nextElementSibling && input.nextElementSibling.classList.contains('lshk-po-help')
      ? input.nextElementSibling
      : null;
    if (!help) {
      // Prefer an existing single help near input
      var near = input.parentElement.querySelector('.lshk-po-help');
      help = near;
    }
    if (!help) {
      help = document.createElement('p');
      help.className = 'lshk-po-help';
      help.id = helpId;
      help.style.cssText = 'margin:6px 0 0;font-size:12px;line-height:1.4;color:#505759;';
      help.textContent = t(HELP_EN, HELP_ZH);
      input.insertAdjacentElement('afterend', help);
    } else {
      help.id = helpId;
      help.textContent = t(HELP_EN, HELP_ZH);
    }

    var err = help.nextElementSibling && help.nextElementSibling.classList.contains('lshk-po-error')
      ? help.nextElementSibling
      : input.parentElement.querySelector('.lshk-po-error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'lshk-po-error';
      err.id = errId;
      err.setAttribute('role', 'alert');
      err.style.cssText = 'display:none;margin:6px 0 0;font-size:13px;line-height:1.4;color:#b00020;font-weight:600;';
      help.insertAdjacentElement('afterend', err);
    } else {
      err.id = errId;
    }

    cleanupDuplicates(input);
    input.setAttribute('aria-describedby', [helpId, errId].join(' '));
    input.setAttribute('data-lshk-po-enhanced', '1');
    return { help: help, err: err, wrap: input.parentElement };
  }

  function showError(input, message) {
    var bits = ensureLabelAndHelp(input);
    bits.err.textContent = message || '';
    bits.err.style.display = message ? 'block' : 'none';
    input.setAttribute('aria-invalid', message ? 'true' : 'false');
    if (message) {
      try { input.focus({ preventScroll: false }); } catch (e) { input.focus(); }
      input.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }

  function clearError(input) {
    showError(input, '');
  }

  function validateAll() {
    var inputs = findNameInputs();
    if (!inputs.length) return { ok: true, inputs: inputs };
    var firstBad = null;
    inputs.forEach(function (input) {
      ensureLabelAndHelp(input);
      var result = validate(input.value);
      if (!result.ok) {
        showError(input, result.message);
        if (!firstBad) firstBad = { input: input, result: result };
      } else {
        clearError(input);
      }
    });
    return { ok: !firstBad, firstBad: firstBad, inputs: inputs };
  }

  function onInput(e) {
    var input = e.target;
    if (!isNameInput(input)) return;
    ensureLabelAndHelp(input);
    // Live feedback without trimming
    var result = validate(input.value);
    if (input.value.trim() === '') {
      clearError(input);
      return;
    }
    if (!result.ok && result.reason === 'limit') {
      showError(input, result.message);
    } else {
      clearError(input);
    }
  }

  function blockIfInvalid(e) {
    var check = validateAll();
    if (check.ok) return;
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    }
    return false;
  }

  function isAddToCartControl(el) {
    if (!el || !el.closest) return null;
    var btn = el.closest('button, [type="submit"], input[type="submit"], [name="add"]');
    if (!btn) return null;
    var text = ((btn.innerText || btn.value || btn.getAttribute('aria-label') || '') + '').toLowerCase();
    if (/add to cart|加入購物車|add\s*to\s*bag|checkout|buy it now|立刻購買|立即購買/.test(text)) return btn;
    if (btn.name === 'add' || btn.getAttribute('name') === 'add') return btn;
    if (btn.classList && (btn.classList.contains('add-to-cart') || btn.classList.contains('product-form__cart-submit'))) return btn;
    return null;
  }

  function onClickCapture(e) {
    var btn = isAddToCartControl(e.target);
    if (!btn) return;
    if (!findNameInputs().length) return;
    blockIfInvalid(e);
  }

  function onSubmitCapture(e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    if (!findNameInputs(form).length && !findNameInputs().length) return;
    // Product forms typically post to /cart/add
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1 && form.getAttribute('data-product-form') == null && !form.querySelector('[name="id"]')) {
      // still validate if hulk inputs present on page and submit looks like product ATC
      if (!findNameInputs().length) return;
    }
    blockIfInvalid(e);
  }

  function enhance() {
    findNameInputs().forEach(ensureLabelAndHelp);
  }

  document.addEventListener('input', onInput, true);
  document.addEventListener('change', onInput, true);
  document.addEventListener('click', onClickCapture, true);
  document.addEventListener('submit', onSubmitCapture, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance);
  } else {
    enhance();
  }
  // Hulk injects late — enhance a few times, then observe
  var tries = 0;
  var timer = setInterval(function () {
    enhance();
    tries++;
    if (tries > 12) clearInterval(timer);
  }, 800);
  if (window.MutationObserver) {
    var obsTimer = null;
    var obs = new MutationObserver(function () {
      if (obsTimer) return;
      obsTimer = setTimeout(function () {
        obsTimer = null;
        enhance();
      }, 300);
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
